<div class="button button-luna button-{{_type}} button--{{color}}" (click)="click()" [class.button--active]="active">
    <app-loading [showText]="false" *ngIf="loading"></app-loading>
    <ng-container *ngIf="!loading">
        <i-tabler [name]="iconName" *ngIf="iconName" class="icon-36"></i-tabler>
        <p *ngIf="label" class="button-label">{{label}}</p>
    </ng-container>
</div>
